<template>
  <div v-if="userId" class="container-narrow">
    <b-steps
      v-model="activeStep"
      :has-navigation="hasNavigation"
      :destroy-on-hide="destroyOnHide"
      :mobile-mode="mobileMode"
    >
      <b-step-item step="1">
        <template v-if="!addressLoading">
          <Address
            v-on:update:is-address-invalid="addressInvalidField = $event"
            :is-address-invalid="addressInvalidField"
            product="test"
          />
          <b-button
          class="mt-2"
            type="is-blue"
            :disabled="addressInvalidField"
            @click="toFinal"
            expanded
          >
            Verify and Pay
          </b-button>
        </template>
      </b-step-item>
      <b-step-item step="2">
        <Payment product="test" />
        <b-button
          class="mt-2"
            type="is-blue"
            @click="redirectToPayment"
            expanded
          >
            Pay
          </b-button>
      </b-step-item>
    </b-steps>
  </div>
  <div class="container-narrow" v-else>
    <FourOFour />
  </div>
</template>

<script>
import { loadStripe } from '@stripe/stripe-js/pure';
import { mapActions, mapState, mapGetters } from 'vuex';
import Address from '@/components/Forms/Address.vue';
import Payment from '@/components/Forms/Payment.vue';
import FourOFour from '@/views/404.vue';
import { createSnackbar, stripeKey } from '@/common';

const stripePromise = loadStripe(stripeKey);

export default {
  data: () => ({
    activeStep: 0,
    hasNavigation: false,
    destroyOnHide: true,
    mobileMode: 'minimalist',
    addressInvalidField: 'Address',
    addressLoading: false,
  }),
  computed: {
    ...mapState({
      userId: ({ personalDetails: { userId } }) => userId,
    }),
    ...mapGetters(['getSessionId']),
  },
  methods: {
    ...mapActions(['updateContact', 'toCheckout']),
    createSnackbar,
    async toFinal() {
      try {
        await this.updateContact();
        this.activeStep += 1;
      } catch (error) {
        this.createSnackbar('Please check the address or try again later. If problem persists, you can contact us!');
        throw error;
      }
    },
    async redirectToPayment() {
      try {
        await this.toCheckout();
      } catch (error) {
        this.createSnackbar(
          'Error in intitating Checkout. Please try again later.',
        );
        throw error;
      }
      try {
        const stripe = await stripePromise;
        const { error } = await stripe.redirectToCheckout({
          sessionId: this.getSessionId,
        });
        if (error) {
          this.createSnackbar('Error in initiating checkout');
          throw error;
        }
        return null;
      } catch (error) {
        this.createSnackbar(
          'Error in intitating Checkout. Please try again later.',
        );
        throw error;
      }
    },
  },
  components: {
    Address,
    FourOFour,
    Payment,
  },
};
</script>
